<template>
  <div>
    <page-header
      slot="header"
      ref="header"
      @submit="handleSubmit"
      @addMasterSample="addMasterSample"
    ></page-header>
    <page-main
      class="mt-2"
      ref="main"
      :table-data="table"
      :params="params"
      :loading="loading"
      @submit="handleSubmit"
    />
    <p></p>
    <js-pagination
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      align="right"
      @change="handlePaginationChange"
    />
  </div>
</template>

<script>
export default {
  components: {
    PageHeader: () => import('./components/header'),
    PageMain: () => import('./components/main')
    // 'PageFooter': () => import('@/components/pagination')
  },
  props: {
    params: {
      default: null,
      type: Object
    },
    disabled: {
      default: true,
      type: Boolean
    },
    autoLoad: {
      default: false,
      type: Boolean
    }
  },
  watch: {
    params: {
      handler() {
        if (this.autoLoad) {
          this.handleSubmit()
        }
      },
      deep: true
    }
  },
  data() {
    return {
      table: [],
      loading: false,
      page: {
        curPage: 1,
        pageSize: 5,
        pageTotal: 0
      }
    }
  },
  methods: {
    load() {
      this.handleSubmit()
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.$nextTick(() => {
        this.$refs.header.query()
      })
    },
    // 加载表格数据
    handleSubmit(params) {
      this.loading = true
      this.$api
        .listSeniorApi({
          ...params,
          ...this.params,
          ...this.page
        })
        .then((res) => {
          this.loading = false
          this.page.pageTotal = res.body.count
          this.table = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    addMasterSample() {
      this.$emit('addMasterSample')
    }
  },
  computed: {
    selected() {
      return this.$refs.main.multipleSelection
    }
  }
}
</script>
